export default {"src":"/_next/static/media/search_icon_black.1e5a52ff.svg","height":33,"width":31,"blurWidth":0,"blurHeight":0};